import { render, staticRenderFns } from "./PopOrderCuhaoping.vue?vue&type=template&id=88f4447c&scoped=true&"
import script from "./PopOrderCuhaoping.vue?vue&type=script&lang=js&"
export * from "./PopOrderCuhaoping.vue?vue&type=script&lang=js&"
import style0 from "./PopOrderCuhaoping.vue?vue&type=style&index=0&id=88f4447c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f4447c",
  null
  
)

export default component.exports